import { render, staticRenderFns } from "./uploadBulkCSVfile.vue?vue&type=template&id=7bdfdf10&scoped=true"
import script from "./uploadBulkCSVfile.vue?vue&type=script&lang=js"
export * from "./uploadBulkCSVfile.vue?vue&type=script&lang=js"
import style0 from "./uploadBulkCSVfile.vue?vue&type=style&index=0&id=7bdfdf10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdfdf10",
  null
  
)

export default component.exports